export default {
  setLocale (context, payload) {
    context.commit('setLocale', payload)
  }
}
